import React, { useEffect, useRef, useState } from "react";
import { Table, Button, Form } from "react-bootstrap";
import Layout from "../../components/Layout";
import { useNavigate } from "react-router-dom";
import ToastFile from "../../utils/ToastFile";
import { getAllTaskLogbyContractor } from "../../api/TaskApi";
import moment from "moment";
import Select from "react-select";
import { getAllEmployeebyContractor } from "../../api/EmployeeApi";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { MdDelete } from "react-icons/md";
import { deletePaySlipByID, getAllPaySlipByTenant } from "../../api/ReportApi";
import DeleteModel from "../../components/DeleteModel";
import Loader from "../../components/Loader";

const PaySlip = () => {
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [employees, setEmployees] = useState([]);
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [slipData, setSlipData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(0);
  const [isLoading, setIsloading] = useState(true);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getEmployee();
    getPaySlip();
  }, []);

  const getEmployee = () => {
    getAllEmployeebyContractor(user.tenant_id)
      .then((res) => {
        const emps = res?.data?.data?.employees || [];
        setEmployees(emps);
        const options = emps.map((emp) => ({
          value: emp._id,
          label: emp.name,
        }));
        setEmployeeOptions(options);
      })
      .catch((err) => {
        console.error("Error fetching employees:", err);
      });
  };

  const getPaySlip = () => {
    setIsloading(true)
    getAllPaySlipByTenant(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          setSlipData(res?.data?.data?.payslips);
        }
      })
      .catch((err) => {
        console.error("Error fetching slips:", err);
      })
      .finally(()=>{
         setIsloading(false)
      })
  };

  const deleteSlip = () => {
    deletePaySlipByID(slipData[deleteIndex]._id)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Slip deleted", "deleted");
          getPaySlip();
        } else {
          ToastFile("Failed to delete slip", "error");
        }
      })
      .catch((err) => {
        console.error("Error deleting slip:", err);
        ToastFile("Error deleting slip", "error");
      })
      .finally(() => {
        setDeleteIndex(0);
        setDeleteModal(false);
      });
  };

  const onSelect = (employee_id) => {
    setSelectedEmployee(employee_id);
  };

  const generateSalarySlip = async () => {
    let startDate = date?.startDate
      ? moment(new Date(date.startDate)).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD");
    let endDate = date?.endDate
      ? moment(new Date(date.endDate)).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD");
    navigate("/generateslip", {
      replace: true,
      state: { startDate, endDate, selectedEmployee },
    });
  };

  return (
    <Layout>
      <DeleteModel
        showModal={deleteModal}
        setShowModal={setDeleteModal}
        onYes={deleteSlip}
      />
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
        <h3 className="mb-0">Salary Slips</h3>
      </div>
      <div className="card mb-4">
        <div className="card-body">
          <Form>
            <div className="row g-3">
              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Employee</Form.Label>
                  <Select
                    options={employeeOptions}
                    placeholder="Search employee"
                    onChange={(selected) => onSelect(selected?.value)}
                    isClearable
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </Form.Group>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="startDate"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setDate((prev) => ({
                        ...prev,
                        startDate: e.target.value,
                      }))
                    }
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label className="fw-bold">End Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="endDate"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setDate((prev) => ({ ...prev, endDate: e.target.value }))
                    }
                  />
                </Form.Group>
              </div>
              <div className="col-12 col-md-6 col-lg-3 d-flex align-items-end">
                <Button
                  variant="success"
                  onClick={generateSalarySlip}
                  className="w-100 d-flex align-items-center justify-content-center gap-2"
                >
                  Generate Salary slip
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
      <div>
        <Table bordered responsive size="sm">
          <thead className="table-dark">
            <tr style={{ textAlign: "center" }}>
              <th>Slip No</th>
              <th>Payment Date</th>
              <th>Employee </th>
              <th>Company Name</th>
              <th>Pay Period</th>
              <th>Ordinary Hours</th>
              <th>Total Amount</th>
              <th className="text-nowrap">Actions</th>
            </tr>
          </thead>
          {isLoading ? <tbody>
              <tr>
                <td colSpan="7">
                  <Loader/>
                </td>
              </tr>
            </tbody>
            :
          <tbody>
            {slipData?.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center">
                  No data
                </td>
              </tr>
            ) : (
              slipData?.map((slip, idx) => (
                <tr key={idx}>
                  <td>{slip.slipNumber}</td>
                  <td style={{ textAlign: "center" }}>
                    {moment(slip.date).format("DD/MM/YYYY")}
                  </td>
                  <td>
                    {
                      employees.find((emp) => emp._id === slip.employee_id)
                        ?.name
                    }
                  </td>
                  <td>{slip.companyName}</td>
                  <td style={{ textAlign: "center" }}>
                    {moment(slip.startDate).format("DD/MM/YYYY")} -{" "}
                    {moment(slip.endDate).format("DD/MM/YYYY")}
                  </td>
                  <td style={{ textAlign: "end" }}>{slip.ordinaryHours}</td>
                  <td style={{ textAlign: "end" }}>{slip.totalAmount}</td>
                  <td className="text-nowrap">
                    <div className="d-flex justify-content-center gap-2">
                      {/* <button
                              className="btn btn-sm btn-outline-primary border-0"
                              onClick={() => openViewModal(idx)}
                              title="View"
                            >
                              <FaEye size={16} />
                            </button> */}
                      <button
                        className="btn btn-sm btn-outline-danger border-0"
                        onClick={() => {
                          setDeleteIndex(idx);
                          setDeleteModal(true);
                        }}
                        title="Delete"
                      >
                        <MdDelete size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>}
        </Table>
      </div>
    </Layout>
  );
};

export default PaySlip;
